import React from 'react';

import {
  notification,
  Modal,
  Row,
  Col,
  Button,
  Checkbox,
  Select,
  DatePicker,
} from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';
import _ from 'lodash';
import moment from 'moment';
import { Form } from '@ant-design/compatible';
const { RangePicker } = DatePicker;
import { descargarCSV } from '../../administracion/funciones/descargarCSV';

import getDepositosContravencion from '../../../graphql/querys/contravenciones/getDepositosContravencion.graphql';
import getDepositosContravencionPorRangoFecha from '../../../graphql/querys/contravenciones/getDepositosContravencionPorRangoFecha.graphql';
import deleteDepositoContravencion from '../../../graphql/mutations/contravenciones/deleteDepositoContravencion.graphql';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionsPedido from '../../../actions/pedido';
import * as actionsMain from '../../../actions/main';

import getOrganismos from '../../../graphql/querys/organismos/getOrganismos.graphql';
import TablaDepositosContravencion from './TablaDepositosContravencion';
import ModalVerDepositoContravencion from './ModalVerDepositoContravencion';
import { errorService } from '../../../graphql/utils/utils';

const confirm = Modal.confirm;

@compose(
  // graphql(getDepositosContravencion, { options: { fetchPolicy: 'network-only' } }),
  graphql(getOrganismos, { name: 'organismos' }),
  graphql(deleteDepositoContravencion, {
    name: 'deleteDepositoContravencion',
    options: {
      refetchQueries: [{ query: getDepositosContravencion }],
    },
  })
)
class VerDepositosContravencion extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      filtro: props.usuario.organismo._id,
      currentPage: 1,
      listaTotal: [],
      lista: [],
      fechaInicial: moment().subtract(7, 'd'),
      fechaFinal: moment(),
      pedido: {},
      reporteGeneral: false,
      showTable: false,
      showCheckbox: false,
      rolAutorizado: false,
    };

    this.onDelete = this.onDelete.bind(this);
  }

  componentDidMount() {
    const { usuario } = this.props;
    if (usuario.rol === 'SUPERVISOR' || usuario.rol === 'ADMINISTRADOR') {
      this.setState({
        showCheckbox: true,
        rolAutorizado: true,
      });
    }
  }

  onDelete(idDeposito) {
    //TODO: Hacer el onDelete.

    let yo = this;
    confirm({
      title: 'Realmente quiere eliminar este deposito contravencional?',
      content: 'Esta accion no podrá deshacerse',
      onOk() {
        yo.props
          .deleteDepositoContravencion({
            variables: { _id: idDeposito },
          })
          .then(res => {
            let id = res.data.deleteDepositoContravencion;

            if (id) {
              yo.eliminarElementoYActualizarLista(id);
              notification.warning({
                message: 'Deposito contravencional eliminado',
                description: 'Se ha eliminado el deposito exitosamente',
              });
            }
          })
          .catch(err => {
            console.log('Existio un error a la hora de eliminar el deposito');
            console.log(err);

            errorService(err, {
              _id: idDeposito,
              accion: 'ELIMINAR DEPOSITO CONTRAVENCIONAL',
            });

            Modal.error({
              title: 'Error en la eliminacion del envio',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  eliminarElementoYActualizarLista = idElemento => {
    //Esta funcion esta encargada de eliminar el elemento de la lista, actualizar el estado y re-generar la lista.
    let lTotal = [...this.state.listaTotal];

    _.remove(lTotal, elem => {
      return elem._id == idElemento;
    });
    this.setState({
      ...this.state,
      listaTotal: lTotal,
    });
  };

  cambiarOrganismo = idOrganismo => {
    // console.log('Voy a cambiar el organismo: ', idOrganismo);
    this.setState({
      ...this.state,
      idOrganismo: idOrganismo,
      filtro: idOrganismo,
    });
  };

  obtenerNombreOrganismo = idOrganismo => {
    let nombre = '';
    let organismo = _.find(this.props.data.getOrganismos, { _id: idOrganismo });
    organismo ? (nombre = organismo.nombre) : (nombre = '');
    return nombre;
  };

  _executeSearch = async () => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.
    this.setState({ loading: true });
    this.props.client
      .query({
        query: getDepositosContravencionPorRangoFecha,
        variables: {
          idOrganismo: this.state.filtro,
          fechaInicio: this.state.fechaInicial,
          fechaFin: this.state.fechaFinal,
        },
        options: { fetchPolicy: 'network-only' },
      })
      .then(res => {
        // console.log('LISTA ==>', res.data);
        let lista = res.data.getDepositosContravencionPorRangoFecha;
        this.setState({
          loading: false,
          lista: lista,
          showTable: true,
        });
      })
      .catch(err => {
        console.log('ERROR: ', err);
        errorService(err, {
          variables: {
            idOrganismo: this.state.filtro,
            fechaInicio: this.state.fechaInicial,
            fechaFin: this.state.fechaFinal,
          },
        });
      });
  };

  onDescargarCSV = () => {
    let data = _.map(this.state.lista, deposito => {
      return {
        fecha: deposito.fechaDeposito
          ? moment(deposito.fechaCreacion).format('DD/MM/YYYY')
          : moment(deposito.fechaCreacion).format('DD/MM/YYYY'),
        organismo: deposito.organismo.nombre,
        importe: deposito.importe,
        tipoPago: deposito.tipo ? deposito.tipo.toUpperCase() : '-',
        numeroReferencia: deposito.numBoletaDeposito
          ? deposito.numBoletaDeposito
          : '-',
        sucursal: deposito.sucursal ? deposito.sucursal.nombre : 'SIN DATOS',
        estado: deposito.estado,
      };
    });
    descargarCSV(
      ['FECHA', 'ORGANISMO', 'IMPORTE', 'TIPO PAGO', 'SUCURSAL', 'ESTADO'],
      data,
      `ReporteDepositosContravenciones-${moment(this.state.fechaInicial).format(
        'DD/MM/YYYY'
      )}-${moment(this.state.fechaFinal).format('DD/MM/YYYY')}.csv`
    );
  };

  onChangeFechas = date => {
    // console.log(date);
    if (date !== null) {
      this.setState({
        ...this.state,
        fechaInicial: date[0] ? date[0] : '',
        fechaFinal: date[1] ? date[1] : '',
      });
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    this._executeSearch();
  };

  borrarFiltros = () => {
    this.setState({
      ...this.state,
      filtro: '',
      fechaInicial: null,
      fechaFinal: null,
      lista: this.props.data.getDepositosContravencion,
      listaTotal: this.props.data.getDepositosContravencion,
    });
  };

  mostrarModalVerDepositoContravencion = record => {
    this.setState(
      {
        deposito: record,
      },
      () => {
        this.props.actionsMain.setVerDepositoContravencion(
          !this.props.main.verDepositoContravencion
        );
      }
    );
  };

  ocultarModalVerDepositoContravencion = () => {
    // console.log('entre. 2..');
    this.setState(
      {
        deposito: {},
      },
      () => {
        this.props.actionsMain.setVerDepositoContravencion(
          !this.props.main.verDepositoContravencion
        );
      }
    );
  };

  handleShowTable = value => this.setState({ showTable: value });

  handleCheckboxChange = () => {
    if (this.state.filtro === 'todos') {
      this.setState({
        reporteGeneral: false,
        filtro: this.props.usuario.organismo._id,
      });
    } else {
      this.setState({
        reporteGeneral: true,
        filtro: 'todos',
      });
    }
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }
    const { usuario } = this.props;

    const pagination = {
      pageSize: 10,
      current: this.state.currentPage,
      total: this.state.listaTotal ? this.state.listaTotal.length : 0,
    };

    return (
      <div>
        {!this.state.showTable && (
          <>
            <h2 style={{ textAlign: 'center', marginTop: 120 }}>
              Reporte de Depositos Contravencionales
            </h2>

            <Form
              style={{ marginTop: 80 }}
              encType="multipart/form-data"
              onSubmit={this.handleSubmit}
            >
              <Row>
                <Col span={10} style={{ textAlign: 'center', margin: 'auto' }}>
                  <Row>
                    <Col span={5}>
                      <h3>FECHAS: </h3>
                    </Col>
                    <Col span={10}>
                      <RangePicker
                        style={{ width: 350, marginLeft: 10 }}
                        onChange={this.onChangeFechas}
                        defaultValue={[moment().subtract(7, 'd'), moment()]}
                        format={'DD-MM-YYYY'}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row style={{ marginTop: 30 }}>
                <Col span={10} style={{ margin: 'auto' }}>
                  <Row>
                    <Col span={5}>
                      <h3>ORGANISMO: </h3>
                    </Col>
                    <Col span={10}>
                      <Select
                        style={{ width: 350, marginLeft: 10 }}
                        required
                        id="tipoDoc"
                        placeholder="Seleccione un organismo"
                        onSelect={valor => this.cambiarOrganismo(valor)}
                        disabled={
                          this.state.reporteGeneral || !this.state.rolAutorizado
                        }
                        defaultValue={usuario.organismo._id}
                      >
                        {this.props.organismos.getOrganismos &&
                          this.props.organismos.getOrganismos.map(organismo => (
                            <Select.Option
                              key={organismo._id}
                              value={organismo._id}
                            >
                              {organismo.nombre}
                            </Select.Option>
                          ))}
                      </Select>
                    </Col>
                  </Row>
                </Col>
              </Row>
              {this.state.showCheckbox && (
                <Row>
                  <Col style={{ margin: 'auto', marginTop: 20 }}>
                    <Checkbox
                      onChange={this.handleCheckboxChange}
                      checked={this.state.reporteGeneral}
                    >
                      Incluir todos los Organismos
                    </Checkbox>
                  </Col>
                </Row>
              )}
              <Row style={{ marginTop: 30, marginBottom: 100 }}>
                <Col style={{ margin: 'auto' }}>
                  <Button type="primary" htmlType="submit">
                    Generar Reporte
                  </Button>
                </Col>
              </Row>
            </Form>
          </>
        )}
        {this.state.showTable && (
          <>
            <TablaDepositosContravencion
              depositosContravencionales={this.state.lista}
              pagination={pagination}
              onChange={this.onChangeFechas}
              onDelete={this.onDelete}
              organismos={this.props.organismos.getOrganismos}
              usuario={usuario}
              cambiarOrganismo={this.cambiarOrganismo}
              mostrarModalVerDepositoContravencion={
                this.mostrarModalVerDepositoContravencion
              }
              history={this.props.history}
              verTabla={this.handleShowTable}
              onDescargar={this.onDescargarCSV}
            />
            {this.props.main.verDepositoContravencion && (
              <ModalVerDepositoContravencion
                mostrarModalVerDepositoContravencion={
                  this.props.main.verDepositoContravencion
                }
                ocultarModalVerDepositoContravencion={
                  this.ocultarModalVerDepositoContravencion
                }
                deposito={this.state.deposito}
              />
            )}
          </>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actionsPedido: bindActionCreators(actionsPedido, dispatch),
  actionsMain: bindActionCreators(actionsMain, dispatch),
});

function mapStateToProps(state) {
  // console.log('mapStateToPorps: ', state);
  return state;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withApollo(VerDepositosContravencion));
